import { useToggleState } from '@cian/react-utils';
import { UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { DangerouslyInnerHTMLElement } from '@/app/shared/components/DangerouslyInnerHTMLElement';

import styles from './Accordion.css';

type AccordionProps = {
  title: string;
  content: string;
  bodyId: string;
  headingId: string;
  bottomBorder?: boolean;
};

export const Accordion: FC<AccordionProps> = props => {
  const { content, title, bottomBorder, bodyId, headingId } = props;

  const { state: expanded, toggle } = useToggleState(false);

  return (
    <div
      className={clsx(styles['container'], expanded && styles['expanded'], bottomBorder && styles['bottom-divider'])}
      data-testid={'seo.accordion.container'.concat(expanded ? '.expanded' : '')}
    >
      <UIHeading4>
        <div
          aria-controls={bodyId}
          aria-expanded={expanded}
          className={styles['title']}
          data-testid="seo.accordion.heading"
          id={headingId}
          role="button"
          tabIndex={0}
          onClick={toggle}
        >
          <DangerouslyInnerHTMLElement data-testid="heading.seo-data" html={title} />
          <div className={styles['title-icon-wrapper']}>
            <IconActionChevronDown16 color="icon-secondary-default" />
          </div>
        </div>
      </UIHeading4>
      <UIText1 data-testid="seo.accordion.content">
        <div className={styles['content-container']}>
          <DangerouslyInnerHTMLElement
            aria-describedby={headingId}
            className={styles['content']}
            data-testid="content.seo-data"
            html={content}
            id={bodyId}
          />
        </div>
      </UIText1>
    </div>
  );
};
